import { call, put } from 'redux-saga/effects';
import {
	LOGGED_IN_SUCCESS,
	SEND_OTP_SUCCESS,
	REGISTER_USER_SUCCESS,
	MOBILE_NOT_EXIST,
	MOBILE_EXIST,
	REGISTER_USER_FAILED,
	UPDATE_MOBILE_SUCCESS,
	LOGOUT_SUCCESS,
	LOGOUT_FAILED,
	VERIFY_EMAIL_SUCCESS,
	OTP_VERIFICATION_FAILED
} from '../actions/types';
import { checkMobileService, logoutService, registerUserService, sendOTPService, updateMobileService, verifyOTPService, verifyEmailService } from '../services/authentications';

export function* checkMobile(action) {
	try {
		const result = yield call(checkMobileService, action.payload);
		yield put({ type: MOBILE_NOT_EXIST, data: result });
	} catch (error) {
		yield put({ type: MOBILE_EXIST, data: error });
	}
}

export function* sendOtp(action) {
	try {
		const result = yield call(sendOTPService, action.payload);
		yield put({ type: SEND_OTP_SUCCESS, data: result });
	} catch (error) {
		console.log('Error', error);
	}
}

export function* verifyEmail(action) {
	try {
		const result = yield call(verifyEmailService, action.payload);
		console.log(result)
		yield put({ type: VERIFY_EMAIL_SUCCESS, data: result });
	} catch (error) {
		console.log('Error', error);
	}
}

export function* verifyOTP(action) {
	try {
		const result = yield call(verifyOTPService, action.payload);
		yield put({ type: LOGGED_IN_SUCCESS, data: result });
	} catch (error) {
		console.log('Error', error);
		yield put({ type: OTP_VERIFICATION_FAILED, data: error.data.response.data });
	}
}

export function* registerUser(action) {
	try {
		const result = yield call(registerUserService, action.payload);
		yield put({ type: REGISTER_USER_SUCCESS, data: result });
	} catch (error) {
		yield put({ type: REGISTER_USER_FAILED, data: error.response.data });
	}
}

export function* updateMobile(action) {
	try {
		const result = yield call(updateMobileService, action.payload);
		yield put({ type: UPDATE_MOBILE_SUCCESS, data: result });
	} catch (error) {
		console.log('Error', error);
	}
}

export function* logoutUser() {
	try {
		const result = yield call(logoutService);
		console.log('logout', result);
		yield put({ type: LOGOUT_SUCCESS, data: result });
	} catch (error) {
		yield put({ type: LOGOUT_FAILED });
	}
}
